import { useTranslation } from "react-i18next";

import { ReviewVisitTableHeaderCell } from "~/modules/project/screens/ProjectReviewVisitV2Screen/components/ReviewVisitTable";

export function WeatherReportsTableHeader() {
    const { t } = useTranslation("project");

    return (
        <>
            <ReviewVisitTableHeaderCell>
                {t("projectReviewVisitV2.weatherReportsRoute.table.conditions")}
            </ReviewVisitTableHeaderCell>
            <ReviewVisitTableHeaderCell>
                {t("projectReviewVisitV2.weatherReportsRoute.table.start")}
            </ReviewVisitTableHeaderCell>
            <ReviewVisitTableHeaderCell sx={{ gridColumn: "-3/-1" }}>
                {t("projectReviewVisitV2.weatherReportsRoute.table.end")}
            </ReviewVisitTableHeaderCell>
        </>
    );
}
